/* eslint-disable */

<template>
  <div class="login">
    <!-- Modal -->
    <div
      class="modal fade"
      id="login"
      tabindex="-1"
      role="dialog"
      aria-labelledby="loginTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <!--             <ul class="nav nav-fill nav-pills mb-3" id="pills-tab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="pills-home-tab"
                  data-toggle="pill"
                  href="#pills-login"
                  role="tab"
                  aria-controls="pills-login"
                  aria-selected="true"
                >Login</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-register-tab"
                  data-toggle="pill"
                  href="#pills-register"
                  role="tab"
                  aria-controls="pills-register"
                  aria-selected="false"
                >Signup</a>
              </li>
            </ul>-->

            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade"
                :class="modalType == 'login' ? 'show active' : ''"
                id="pills-login"
                role="tabpanel"
                aria-labelledby="pills-login-tab"
              >
                <!-- <h3 class="text-center font-weight-bold mt-3 mb-5">Bulky TMS</h3> -->
                <div class="text-center">
                  <img
                    class="img-responsive mt-4 mb-5"
                    src="/img/BulkyLogoLogin.png"
                    alt="User picture"
                  />
                </div>
                <div class="form-group">
                  <!-- <label for="exampleInputEmail1">Email address</label> -->
                  <input
                    type="email"
                    v-model="email"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Email"
                  />
                </div>
                <div class="form-group">
                  <!-- <label for="exampleInputPassword1">Password</label> -->
                  <input
                    type="password"
                    @keyup.enter="login"
                    v-model="password"
                    class="form-control"
                    id="exampleInputPassword1"
                    placeholder="Password"
                  />
                </div>

                <div class="form-group mb-4">
                  <button class="btn btn-primary btn-block" @click="login">
                    Login
                  </button>
                </div>

                <div class="form-group">
                  <!--<p class="text-center">
                    Don't have an account?
                    <a href="#" v-on:click="setModalType('register')">Sign up</a>
                  </p>-->
                  <p class="text-center">
                    Forgot password?
                    <a
                    href="#"
                role="button"
                v-on:click="setModalType('reset')"
                  >Reset password</a>
                  </p>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="pills-register"
                role="tabpanel"
                :class="modalType == 'register' ? 'show active' : ''"
                aria-labelledby="pills-register-tab"
              >
                <h5 class="text-center">Create New Account</h5>

                <div class="form-group">
                  <label for="name">Your name</label>
                  <input
                    type="text"
                    v-model="name"
                    class="form-control"
                    id="name"
                    placeholder="Your Name"
                  />
                </div>

                <div class="form-group">
                  <label for="name">Your Address</label>
                  <input
                    type="text"
                    v-model="address"
                    class="form-control"
                    id="address"
                    placeholder="Your Address"
                  />
                </div>

                <div class="form-group">
                  <label for="name">Phone</label>
                  <input
                    type="text"
                    v-model="phone"
                    class="form-control"
                    id="phone"
                    placeholder="Your Phone"
                  />
                </div>

                <div class="form-group">
                  <label for="email">Email</label>
                  <input
                    type="email"
                    v-model="email"
                    class="form-control"
                    id="email"
                    aria-describedby="emailHelp"
                    placeholder="Your email"
                  />
                </div>
                <div class="form-group">
                  <label for="password">Password</label>
                  <input
                    type="password"
                    v-model="password"
                    class="form-control"
                    id="password"
                    placeholder="Password"
                  />
                </div>

                <div class="form-group">
                  <button class="btn btn-primary" @click="register">
                    Signup
                  </button>

                  <p class="text-center">
                    
                    <a href="#" v-on:click="setModalType('login')">Login to your account</a>
                  </p>
                </div>
              </div>
              <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade"
                :class="modalType == 'reset' ? 'show active' : ''"
                id="pills-reset"
                role="tabpanel"
                aria-labelledby="pills-reset-tab"
              >
                <!-- <h3 class="text-center font-weight-bold mt-3 mb-5">Bulky TMS</h3> -->
                <div class="text-center">
                  <img
                    class="img-responsive mt-4 mb-5"
                    src="/img/BulkyLogoLogin.png"
                    alt="User picture"
                  />
                </div>
                <div class="form-group">
                  <!-- <label for="exampleInputEmail1">Email address</label> -->
                  <input
                    type="email"
                    v-model="email"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Email"
                  />
                </div>

                <div class="form-group mb-4">
                  <button class="btn btn-primary btn-block" v-on:click="sendPasswordReset">
                    Send Password Reset
                  </button>
                </div>

                <div class="form-group">
                  <!--<p class="text-center">
                    Don't have an account?
                    <a href="#" v-on:click="setModalType('register')">Sign up</a>
                  </p>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>


<script>
import { fb, db, auth } from "../firebase";
import { dbSchema } from "../store"
export default {
  name: "Login",
  props: {
    msg: String
  },
  data() {
    return {
      modalType: "login",
      name: null,
      address: null,
      phone: null,
      email: null,
      password: null,
      zone: null,
      role: null
    };
  },
  methods: {
    setModalType(type) {
      
      this.modalType = type
    },
    sendPasswordReset() {
      const email = "magerx1794@gmail.com"
  
        auth.sendPasswordResetEmail(email).then((() => {

          this.setModalType("login")
        }).bind(this)).catch((error) => {var errorCode = error.code; var errorMessage = error.message; })
    },
    login() {
      fb.auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          $("#login").modal("hide");
          window.location.reload();
        })
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          if (errorCode === "auth/wrong-password") {
            alert("Wrong password.");
          } else {
            alert(errorMessage);
          }
        });
    },
    register() {

      fb.auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(user => {
          $("#login").modal("hide");
          // Add a new document in collection "uzers"
          // Has nothing to do with adding a new request
          db.collection(dbSchema.users)
            .doc(user.user.uid)
            .set({
              name: this.name,
              email: this.email,
              address: this.address,
              phone: this.phone,
              zone: this.zone,
              role: "Resident"
            })
            .then(function() {
              
            })
            .catch(function(error) {
              console.error("Error writing document: ", error);
            });
          this.$router.replace("/");
        })
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          if (errorCode == "auth/weak-password") {
            alert("The password is too weak.");
          } else {
            alert(errorMessage);
          }
          console.log(error);
        });
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>